module.exports = __webpack_public_path__ + "static/araucaria_r2-1d641259cdf48971a1d5bcb36e6db91c.png";